import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M8.84499 6.952C8.56599 7.365 8.34999 7.691 8.23999 8H6.19199C6.31399 7.131 6.79799 6.409 7.18899 5.831C7.93399 4.73 8.23199 4.199 7.50199 3.124L9.15599 2C10.6779 4.24284 9.57499 5.873 8.84499 6.952Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M17 12H17.503C19.431 12 21 13.568 21 15.497C21 17.426 19.431 18.994 17.503 18.994H16.083C14.985 20.794 13.008 22 10.745 22H9.21298C5.75798 22 2.95798 19.2 2.95798 15.745V9.99998H11.048C10.039 8.18798 10.972 6.80698 11.632 5.83098C12.377 4.73098 12.675 4.19898 11.945 3.12398L13.599 2.00098C15.1209 4.24281 14.0181 5.87274 13.2881 6.95174C12.5031 8.11174 12.179 8.59198 13.479 9.89198L13.371 9.99998H17V12ZM10.745 20C13.091 20 15 18.091 15 15.745V12H4.95798V15.745C4.95798 18.091 6.86698 20 9.21298 20H10.745ZM16.875 16.994H17.503C18.329 16.994 19 16.322 19 15.497C19 14.672 18.329 14 17.503 14H17V15.745C17 16.173 16.957 16.59 16.875 16.994Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconAmenities = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconAmenities.displayName = "IconAmenities";

export { IconAmenities };
